function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0261 16.822L10.9909 19.2971H9.01929L10.0261 16.822Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 0C8.30612 0 0 8.26417 0 18.5C0 28.6939 8.30612 37 18.5 37C28.7358 37 37 28.6939 37 18.5C37 8.26417 28.7358 0 18.5 0ZM12.2494 22.4853L11.5782 20.8073H8.47392L7.80272 22.4853H5.87302L9.31293 14.5147H10.7812L14.2211 22.4853H12.2494ZM21.9819 22.4853H20.22V19.0454H16.78V22.4853H15.0181V14.5147H16.78V17.4932H20.178V14.5147H21.9399V22.4853H21.9819ZM29.1553 22.4853L28.4841 20.8073H25.3798L24.7086 22.4853H22.7789L26.2188 14.5147H27.6871L31.1689 22.4853H29.1553ZM25.9252 19.2971H27.8549L26.89 16.822L25.9252 19.2971Z",
  fill: "white"
});

var SvgLogoWhite = function SvgLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-white.cbfb97dc.svg";
export { ForwardRef as ReactComponent };